import PersonIcon from "@mui/icons-material/Person";
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";
import DescriptionIcon from "@mui/icons-material/Description";
import GroupsIcon from "@mui/icons-material/Groups";
import FolderIcon from "@mui/icons-material/Folder";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import GavelIcon from "@mui/icons-material/Gavel";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";

export const TYPE_KB = 1
export const TYPE_OTB = 2
export const TYPE_BOTH = 3
export const GS_DAY_NAMES = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const BACKEND_BASE_URL = window.appConfig.API_BASE_URL;
export const CLUB_lOGO_PATH = BACKEND_BASE_URL + "uploads/images/clubs/"
export const EVENT_BANNER_PATH = BACKEND_BASE_URL + "uploads/images/events/banner/"
export const EVENT_lOGO_PATH = BACKEND_BASE_URL + "uploads/images/events/logo/"
export const SERIES_BANNER_PATH = BACKEND_BASE_URL + "uploads/images/series/banner/"
export const SERIES_lOGO_PATH = BACKEND_BASE_URL + "uploads/images/series/logo/"
export const SAILOR_BOAT_IMAGE_PATH = BACKEND_BASE_URL + "uploads/images/sailor/boat/"
export const SAILOR_PROFILE_IMAGE_PATH = BACKEND_BASE_URL + "uploads/images/sailor/profile/"

export const SHARING_OPTIONS = {
  1: "Times",
  2: "Times & HCs",
  3: "Times & Entrants",
  4: "Times & HCs & Entrants",
  0: "None",
};

export const THIS_RACE = 1
export const ALL_RACES = 2
export const RANGE_RACES = 3

export const RESULT_COLUMNS = [
  "showPlace", "sailnum", "boatName", "skipper", "startTime", "finishTime", "elapsedTime", "ahc", "correctedTime", "bch", "chc", "score", "pd", "td", "note", "note1", "etOrd"
]

export const COLUMN_LABELS = {
  sailnum: "Sail No",
  boatName: "Boat Name",
  skipper: "Skipper",
  showPlace: "Place",
  startTime: "Start Time",
  finishTime: "Finish Time",
  elapsedTime: "Elapsed Time",
  ahc: "AHC",
  correctedTime: "Corrected Time",
  bch: "BCH",
  chc: "CHC",
  score: "Score",
  pd:"PD",
  td:"TD",
  note: "Note",
  note1: "Note 1",
  "etOrd": "ET Ord"
};

export const RESULT_COLUMNS_OTB = [
  "showPlace", "sailnum", "boatName", "skipper", "crew1", "crew2", "startTime", "finishTime", "otbClass", "yardStick", "elapsedTime", "yardstickCorrectedTime", "ahc", "correctedTime", "bch", "chc", "score", "pd", "td", "note", "note1", "etOrd"
]

export const COLUMN_LABELS_OTB = {
  sailnum: "Sail No",
  boatName: "Boat Name",
  skipper: "Skipper",
  crew1: "Crew 1",
  crew2: "Crew 2",
  showPlace: "Result",
  startTime: "Start Time",
  finishTime: "Finish Time",
  otbClass: "Class",
  yardStick: "YS",
  elapsedTime: "Elapsed Time",
  yardstickCorrectedTime: "YS Cor'DT",
  ahc: "AHC",
  correctedTime: "Corrected Time",
  bch: "BCH",
  chc: "CHC",
  score: "Score",
  pd:"PD",
  td:"TD",
  note: "Note",
  note1: "Note 1",
  "etOrd": "ET Ord"
};

export const ALERT_SCREENS = { finishTimes: "finish time entry", kbEntrant: "kb entrants", otbEntrant: "otb entrants", raceSessionSetup: "race session setup" }

export const RESULTS_BY = {
  pursuitHandicap: "Pursuit Handicap",
  place: "Place",
  customPlace: "Custom-Place",
};

export const ENTRY_MODE_OPTIONS = {
  ADMIN_ONLY: "Admin Only",
  REGISTRATIONS_OPEN: "Registrations Open",
};

// Map tab name (from API) to MUI icon components
export const ENTRY_FORM_ICON_MAP = {
  "Sailor Details": PersonIcon,
  "Boats Info": DirectionsBoatIcon,
  "Entry Options": DescriptionIcon,
  "Full Crew List": GroupsIcon,
  "Boat Documents": FolderIcon,
  "Entry Fees": AttachMoneyIcon,
  "Scoring Options": EmojiEventsIcon,
  "Payment Info": DescriptionIcon,
  "Terms & Conditions": GavelIcon,
  "Terms and Conditions": GavelIcon,
  "Additional Information": InfoOutlinedIcon,
  "Emergency Contacts": HealthAndSafetyIcon,
  "Entry Contact & Skipper Display": AssignmentIndIcon,
};

// Fee Setup
export const FEE_CATEGORY_OPTIONS = [
  { value: "Standard Entry", label: "Standard Entry" },
  { value: "Casual", label: "Casual" },
  { value: "Cart", label: "Cart" },
  { value: "Crew", label: "Crew" },
  { value: "Early Bird Entry", label: "Early Bird Entry" },
  { value: "Late Entry", label: "Late Entry" },
];

export const FEE_CALC_TYPE_OPTIONS = [
  { value: "Fixed", label: "Fixed" },
  { value: "Per Meter", label: "Per Meter" },
  { value: "Per Crew", label: "Per Crew" },
  { value: "Tiered", label: "Tiered" },
];